/**
 * Normaliza texto para comparação/busca: minúsculas, sem acento (NFD + remoção
 * de diacríticos) e sem espaços nas pontas. Ex.: "Pré-Produção" → "pre-producao".
 */
export function normalizeText(value?: string | null): string {
  return (value ?? "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").trim();
}

/** Capitaliza a primeira letra de cada palavra. Ex: "ATORES E FIGURINO" → "Atores E Figurino" */
export function toTitleCase(str: string): string {
  if (!str) return str;
  return str.toLowerCase().replace(/(?:^|\s)\S/g, (char) => char.toUpperCase());
}
